import configDefault from './config/default';
import configBaurde from './config/baurde';
import configImwalkingde from './config/imwalkingde';
import configQuellede from './config/quellede';
import configQuellech from './config/quellech';
import configQuelleat from './config/quelleat';
import configOttoversandat from './config/ottoversandat';
import configUniversalat from './config/universalat';
import configAckermannch from './config/ackermannch';
import configJelmolich from './config/jelmolich';
var tenantComponentConfig = {
    emma: configDefault,
    baurde: configBaurde,
    imwalkingde: configImwalkingde,
    quellede: configQuellede,
    quellech: configQuellech,
    quelleat: configQuelleat,
    ottoversandat: configOttoversandat,
    universalat: configUniversalat,
    ackermannch: configAckermannch,
    jelmolich: configJelmolich,
};
var componentConfig = function (configProps) {
    return tenantComponentConfig["" + ((configProps === null || configProps === void 0 ? void 0 : configProps.companyId) || process.env.FRAGMENT_COMPANYID || 'emma')] || configDefault;
};
export default componentConfig;
//# sourceMappingURL=index.js.map